import { addr } from '@/api/address';
import NavBar from '@/components/Navbar'
import variables from '@/styles/variables.scss'
import { mapGetters } from 'vuex'
import Clipboard from 'clipboard'
import { MessageBox } from 'element-ui'

export const Mixin = {
  components: { NavBar },
  watch: {
    '$route' (to, from) {
      this.$router.go(0);
    },
    list: {
      handler() {
        this.$nextTick(() => {
          let node = document.getElementsByClassName("el-pagination__jump")
          if(node.length>0) {
            for (let index = 0; index < node.length; index++) {
              const element = node[index];
              element.childNodes[0].nodeValue = "跳至";
            }
          }
        })
      },
      immediate: true
    }
  },
  computed: {
    variables() {
      return variables
    },
    ...mapGetters([
      'device'
    ])
  },
  methods: {
    transAddr(url) {
      this.$router.push({ name: "address", query: { key: url } })
      return;
      this.pageLoading = true
      addr({
        UserAddr: url
      }).then(response => {
        this.pageLoading = false
        this.$router.push({ name: "address", query: { key: response.data } })
      }).catch(() => {
        this.pageLoading = false
      })
    },
    handleFilter() {
      this.listQuery.skipCount = 0
      this.tableRq()
    },
    handleSizeChange(val) {
      this.listQuery.skipCount = 0
      this.listQuery.maxResultCount = val
      this.tableRq()
    },
    handleCurrentChange(val) {
      this.listQuery.skipCount = (val-1) * this.listQuery.maxResultCount
      this.tableRq()
    },
    copyFn() {
      var clipboard = new Clipboard('.copy-btn')
      clipboard.on('success', e => {
        MessageBox.confirm('复制成功', '', {
          confirmButtonText: '确定',
          showCancelButton: false,
          // type: 'info',
          center: true
        })
        // 释放内存
        clipboard.destroy()
      })
      clipboard.on('error', e => {
      // 不支持复制
        MessageBox.confirm('该浏览器不支持自动复制', '', {
          confirmButtonText: '确定',
          showCancelButton: false,
          // type: 'info',
          center: true
        })
        // 释放内存
        clipboard.destroy()
      })
    }
  }
}